import React from "react";
import Body from "./components/body";
import Header from "./components/header"
import "./about.css"

function About () {
    return (
        <div>
            <title>Abous Us | PaladiumTechServiceLimited</title>
            <Header />
            <Body />
        </div>
    )
}

export default About;